// localStorage wrappers for Starter Tape: learner progress (completed tapes
// + the Tape Shelf) and per-tape working drafts. Every access is guarded so
// the studio still works in private windows or with storage blocked — it
// just won't remember anything across reloads.

import { isValidSong } from "../../lib/starterTape";
import { emptyProgress, isValidProgress } from "../../lib/starterTapeProgress";

const PROGRESS_KEY = "starterTape.progress.v1";
const draftKey = (id) => `starterTape.draft.${id}.v1`;

const read = (key) => {
  try {
    return JSON.parse(window.localStorage.getItem(key));
  } catch (e) {
    return null;
  }
};

const write = (key, value) => {
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch (e) {
    // storage unavailable — nothing to do
  }
};

export const loadProgress = () => {
  const saved = read(PROGRESS_KEY);
  return isValidProgress(saved) ? saved : emptyProgress();
};

export const saveProgress = (progress) => write(PROGRESS_KEY, progress);

// The song being worked on for a tape (or "sandbox"), or null.
export const loadDraft = (id) => {
  const saved = read(draftKey(id));
  return isValidSong(saved) ? saved : null;
};

export const saveDraft = (id, song) => write(draftKey(id), song);
